import { LOCAL_STORAGE_FEATURE_ENABLED_VALUE } from '~shared/constants/localstorage.constant';

export namespace LocalStorageUtil {
  export const add = (key: string, value: string): void => {
    if(localStorage) {
      localStorage.setItem(key, value);
    }
  };

  export const remove = (key: string): void => {
    if(localStorage) {
      localStorage.removeItem(key);
    }
  };

  export const get = (key: string): string => {
    if(localStorage) {
      return localStorage.getItem(key);
    }
    return null;
  };

  export const isEqual = (key: string, value: string): boolean => {
    const localStorageValue = get(key);
    return localStorageValue && value && localStorageValue === value;
  };

  export const bulkRemove = (keys: string[]): void => {
    keys.forEach((key) => remove(key));
  };

  export const isFeatureEnabled = (key: string): boolean => {
    return isEqual(key, LOCAL_STORAGE_FEATURE_ENABLED_VALUE);
  };

  export const enableFeature = (key: string): void => {
    add(key, LOCAL_STORAGE_FEATURE_ENABLED_VALUE);
  };

  export const disableFeature = (key: string): void => {
    remove(key);
  };
}
